export const brandLogoSid = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
